module.exports = __webpack_public_path__ + "media/images/players/PUIG_DAVID-ff8c3f455b5608ed539319249c854d4c.png";